import { useParams } from "react-router";
import { ResourceCentre } from "../interfaces/ResourceCentreInterface";
import { useAppSelector } from "../store/hooks";

const useCurrentResourceCentre = (): ResourceCentre | undefined => {
  // get id from url for superadmin
  const { id } = useParams<{ id: string }>();

  return useAppSelector((state) => {
    const rcId = state.userContext?.resourceCentreId || Number(id) || undefined;

    if (!rcId) {
      return state.userContext?.resourceCentre;
    }

    return (
      (state.resources?.resourceCentres || []).find((item: ResourceCentre) => item.id === rcId) ||
      state.userContext?.resourceCentre
    );
  });
};

export default useCurrentResourceCentre;
